<template>
  <div class="page flex-col">
    <div class="section_about flex-col">
      <div class="group_1 flex-col">
        <navbar :activeName="activeName" />
        <span class="about_title_cls">{{ activeName }}</span>
        <div class="section_3 flex-col"></div>
      </div>
    </div>
    <div class="box_16 flex-col">
      <bread :activeName="activeName" />
      <div class="block_about_cls flex-row justify-between">
        <div class="box_about_div_cls flex-col justify-between">
          <div class="text-group_6 flex-col justify-between">
            <span class="about_text_cls">{{ company.name | filterNull }}</span>
          </div>
          <span class="text_about_cls" v-html="company.remark" />
        </div>
      </div>

      <bottom :activeName="activeName" />
    </div>
  </div>
</template>
  <script>
import Bottom from "../components/bottom.vue";
import Bread from "../components/bread.vue";
import navbar from "../components/navbar.vue";
import { getTypeList } from "@/api/home";
export default {
  components: { navbar, Bottom, Bread },
  data() {
    return {
      baseURL: this.$apis,
      brandDesc: "蓄巨人品牌故事",
      companyDesc:
        "苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容，苏州加睿博公司介绍内容",
      activeName: "相关协议",
      company: {
        name: "",
        content: "",
        remark: "",
      },
      brand: {
        title: "",
        remark: "",
      },
      future: "",
    };
  },
  created() {
    this.initData();
  },
  filters: {
    filterNull(val) {
      if (val) {
        return val;
      } else {
        return "";
      }
    },
  },
  methods: {
    initData() {
      this.getData();
    },
    getData() {
      var id = this.$route.query.id;
      var params = { type: "agreement" };
      getTypeList(params).then((res) => {
        if (res.code !== 200) {
          this.$message.error(res.msg);
        } else {
          console.log(res);
          let data = res.rows;
          let arr = data.filter((item) => item.id == id);
          this.company = arr[0];
          console.log(arr);
        }
      });
    },
  },
};
</script>
  <style scoped>
.company_image_cls {
  background-image: url(../assets/img/about1.png);
  background-size: 100% 100%;
  width: 435px;
  height: 338px;
}
.company_image_cls1 {
  background-image: url(../assets/img/about3.png);
  background-size: 100% 100%;
  width: 435px;
  height: 277px;
  margin-top: 100px;
}
.brand_image_cls {
  background-image: url(../assets/img/about2.png);
  background-size: 100% 100%;
  width: 435px;
  height: 338px;
  margin-top: 30px;
}
.brand_div_cls {
  width: 100%;
  height: 70px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
.block_about_cls {
  width: 1024px;
  margin: 80px auto 0 auto;
}
::v-deep .block_about_cls img {
  width: 100%;
}
.text_brand_cls {
  height: 53px;
  overflow-wrap: break-word;
  color: rgba(234, 234, 234, 1);
  font-size: 44px;
  font-family: AlimamaShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 53px;
}
.about_text_cls {
  height: 40px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 28px;
  text-align: left;
  white-space: nowrap;
  line-height: 40px;
}
.text_future {
  height: 40px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 28px;
  text-align: left;
  white-space: nowrap;
  line-height: 40px;
  margin: 60px 0 20px 0;
}
.text_future_item {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  text-align: left;
  line-height: 22px;
  margin: 15px 0;
}
.text-wrapper-future {
  width: 1024px;
  height: 500px;
  margin: 0 auto;
}
.box_about_div_cls {
  width: 100%;
}
.text_about_cls {
  min-height: 240px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  line-height: 20px;
  margin-top: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.about_desc_cls {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 10px;
}
.about_title_cls {
  width: 128px;
  height: 45px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 32px;
  text-align: center;
  white-space: nowrap;
  line-height: 45px;
  margin: 220px auto 0 auto;
}
.section_3 {
  background-color: rgba(255, 255, 255, 1);
  width: 48px;
  height: 2px;
  margin: 20px auto 156px auto;
}
.section_about {
  background-image: url(../assets/img/about4.png);
  background-size: 100% 100%;
  height: 480px;
  width: 100%;
}
.group_1 {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 480px;
}
.box_future_div {
  background-image: url(../assets/img/about5.png);
  background-size: 100% 100%;
  height: 500px;
  margin-top: 60px;
  width: 100%;
}
</style>